<title>{{ apiInformation.htmlTitle }}</title>
<app-banner [banner]="apiInformation.banner"></app-banner>
<app-api-information-card [apiInformation]="apiInformation.apiInformationCards"></app-api-information-card>
